/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Product } from './Product'
import { ProductFromJSON, ProductFromJSONTyped, ProductToJSON } from './Product'

/**
 *
 * @export
 * @interface GetDataFourthStage200ResponseData
 */
export interface GetDataFourthStage200ResponseData {
  /**
   * По заявке есть оплаченный сервисный продукт (можно пропустить выбор услуг)
   * @type {boolean}
   * @memberof GetDataFourthStage200ResponseData
   */
  serviceProductPaid: boolean
  /**
   * Доступные услуги (схема Product)
   * @type {Array<Product>}
   * @memberof GetDataFourthStage200ResponseData
   */
  products: Array<Product>
}

/**
 * Check if a given object implements the GetDataFourthStage200ResponseData interface.
 */
export function instanceOfGetDataFourthStage200ResponseData(
  value: object
): value is GetDataFourthStage200ResponseData {
  if (
    !('serviceProductPaid' in value) ||
    value['serviceProductPaid'] === undefined
  )
    return false
  if (!('products' in value) || value['products'] === undefined) return false
  return true
}

export function GetDataFourthStage200ResponseDataFromJSON(
  json: any
): GetDataFourthStage200ResponseData {
  return GetDataFourthStage200ResponseDataFromJSONTyped(json, false)
}

export function GetDataFourthStage200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataFourthStage200ResponseData {
  if (json == null) {
    return json
  }
  return {
    serviceProductPaid: json['serviceProductPaid'],
    products: (json['products'] as Array<any>).map(ProductFromJSON),
  }
}

export function GetDataFourthStage200ResponseDataToJSON(
  value?: GetDataFourthStage200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    serviceProductPaid: value['serviceProductPaid'],
    products: (value['products'] as Array<any>).map(ProductToJSON),
  }
}
